import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import Container from "../../components/container";
import BaseForm from "../../components/form";
import { TextHeader } from "../../components/text";
import { COULMN_DATA } from "./constants/columns";
import { useGetData } from "./hook/useGetData";
import { ContainerData, ContainerSearch, ContainerTable } from "./style/style";
import { EditData } from "./view/modal/edit";
import { TableData } from "./view/table/data";
import qurrystring from "query-string";
import { PrimaryButton } from "../../components/button/primary";
import { SecondaryButton } from "../../components/button/secondary";
import { useGetOption } from "./hook/useGetOption";
import { Divider } from "antd";
import { useDelete } from "./hook/useDelete";
import { IModelRef } from "./interfaces/modal";
import { IStateSpareDevice } from "./interfaces/state";
import { FORM_SEARCH } from "./constants/forms";
import WrapperComponent from "../../components/hoc/WrapperComponent";

const ConfirmSpareDeviceScene = () => {
  const modalRef = useRef<IModelRef>();
  const { onDelete } = useDelete();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const pl = params.get("p");
  const { data, setData, onFetchData, onSearch } = useGetData();
  const { onFetchOptionChangeDevice, optionsChangeDevice } = useGetOption();
  const [loadingTable, setLoadingTable] = useState(true);
  const [forceLoadingSearch, setForceLoadingSearch] = useState(false);
  const [forceLoading, setForceLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit } = useForm({});

  const onFetchSearch = async () => {
    pl && (await onSearch(pl));
    setForceLoading(false);
  };

  useEffect(() => {
    onFetchOptionChangeDevice();
  }, []);

  useEffect(() => {
    setLoadingTable(true);
    onFetchSearch();
    setLoadingTable(false);
  }, [pl]);

  useEffect(() => {
    (async () => {
      setLoadingTable(true);
      await onFetchData();
      setLoadingTable(false);
    })();
  }, []);

  const onSubmitSearch = async () => {
    const {
      search_maintainId,
      search_deviceId,
      search_customerCode,
      search_saleCode,
      search_maintainSpareStatus,
    } = getValues();
    const valueParams = {
      maintainId: search_maintainId,
      deviceId: search_deviceId,
      customerCode: search_customerCode,
      saleCode: search_saleCode,
      maintainSpareStatus: search_maintainSpareStatus,
    };
    const queryString = qurrystring.stringify(valueParams);
    setForceLoadingSearch(true);
    setLoadingTable(true);
    window.history.replaceState(null, "", `spare?${queryString}`);
    await onSearch(queryString);
    setLoadingTable(false);
    setForceLoadingSearch(false);
  };

  const onSubmitClearSearch = async (force?: boolean) => {
    reset();
    force && setForceLoading(true);
    setLoadingTable(true);
    window.history.replaceState(null, "", `?`);
    await onFetchData();
    setLoadingTable(false);
    force && setForceLoading(false);
  };

  function onCallbackEdit(item: IStateSpareDevice) {
    const findIndex = data.findIndex(
      (e) => e.maintainSpareId === item.maintainSpareId
    );
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(JSON.stringify(data));
    d[findIndex].maintainSpareStatus = "STSH-100";
    d[findIndex].deviceSpareId = item.deviceSpareId;
    setData(d);
  }

  const onCallbackDelete = async (item: IStateSpareDevice) => {
    const findIndex = data.findIndex(
      (e) => e.maintainSpareId === item.maintainSpareId
    );
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(JSON.stringify(data)) as IStateSpareDevice[];
    const { maintainSpareId } = d[findIndex];
    const res = await onDelete(`${maintainSpareId}`);
    if (!res) {
      return;
    }
    d.splice(findIndex, 1);
    setData(d.map((e, i) => ({ ...e, index: i + 1 })));
  };

  return (
    <Container>
      <TextHeader text={"คอนเฟิร์มเครื่องสแปร์"} divider={true} />
      <ContainerData>
        <BaseForm
          control={control}
          forms={FORM_SEARCH({ optionsChangeDevice, onSubmitSearch })}
          setValue={setValue}
          getValues={getValues}
        />
        <ContainerSearch>
          <PrimaryButton
            label={"ค้นหา"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ marginTop: "10px", marginRight: "5px" }}
            tabletStyle={{ marginTop: "10px", marginRight: "5px" }}
            isLoading={forceLoadingSearch}
            forceLoading={forceLoadingSearch}
            onPress={handleSubmit(onSubmitSearch)}
          />
          <SecondaryButton
            label={"ล้างข้อมูล"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ marginTop: "10px", marginRight: "5px" }}
            tabletStyle={{ marginTop: "10px", marginRight: "5px" }}
            isLoading={forceLoadingSearch}
            forceLoading={forceLoading}
            onPress={onSubmitClearSearch}
          />
        </ContainerSearch>
      </ContainerData>
      <Divider />
      <ContainerTable>
        <TableData
          columns={COULMN_DATA({
            onEdit: (e: IStateSpareDevice) =>
              modalRef.current && modalRef.current.openModal(e),
            onDelete: (e: IStateSpareDevice) => onCallbackDelete(e),
          })}
          data={data}
          loading={loadingTable}
        />
      </ContainerTable>
      <EditData
        ref={modalRef}
        onCallbackEdit={(e: IStateSpareDevice) => onCallbackEdit(e)}
      />
    </Container>
  );
};

export default WrapperComponent("ConfirmSpareDeviceScene")(
  ConfirmSpareDeviceScene
);
